import { Box, Flex, Image, useToast } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import CustomText from "../../components/text/CustomText";
import CustomButton from "../../components/buttons/CustomButton";
import CompanyInfo from "./components/CompanyInfo";
import PersonalInfo from "./components/PersonalInfo";
import Documents from "./components/Documents";
import { useSendEmail } from "../../utils/wds.api";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Logo from "../../assets/images/white-logo.svg";
import WdsLogo from "../../assets/images/wds-logo.png";
import BgImg from "../../assets/images/auth-bg.svg";
import { registerUser } from "../../redux/actions/auth.actions";
import AboutYou from "./components/AboutYou";
import { getCountries, getTypes } from "../../redux/actions/general.actions";

function Register() {
  const toast = useToast();
  const navigate = useNavigate();

  const dispatch: any = useDispatch();

  const sendEmail = useSendEmail();

  const { loading } = useSelector((state: any) => state.auth);

  const [payload, setPayload] = useState({
    companyName: "",
    jobTitle: "",
    companyEmail: "",
    companyLocation: "",
    companyPhone: "",
    companyAddress: "",
    companyCity: "",
    type: "",
    firstName: "",
    lastName: "",
    personalEmail: "",
    password: "",
    dateOfBirth: "",
    nationality: "",
    personalPhone: "",
    personalCountry: "",
    personalCity: "",
    personalAddress: "",
    profileImg: "",
    documentType: "Passport",
    documentUrls: [],
    interests: [],
    aboutEvent: [],
    domainOfWork: [],
    purposeOfVisit: [],
  });

  const handleUpdateVisitor = () => {
    dispatch(
      registerUser(
        {
          companyInfo: {
            companyName: payload.companyName,
            jobTitle: payload.jobTitle,
            companyEmail: payload.companyEmail,
            companyLocation: payload.companyLocation,
            companyPhone: payload.companyPhone,
            companyAddress: payload.companyAddress,
            companyCity: payload.companyCity,
          },
          personalInfo: {
            name: payload?.firstName + " " + payload.lastName,
            email: payload.personalEmail,
            dateOfBirth: payload.dateOfBirth,
            nationality: payload.nationality,
            personalPhone: payload.personalPhone,
            personalCountry: payload.personalCountry,
            personalCity: payload.personalCity,
            personalAddress: payload.personalAddress,
          },
          documentUrls: payload.documentUrls,
          documentType: payload.documentType,
          profileImg: payload.profileImg,
          interests: payload.interests,
          aboutEvent: payload.aboutEvent,
          domainOfWork: payload.domainOfWork,
          purposeOfVisit: payload.purposeOfVisit,
          password: payload?.password,
          type: payload?.type,
          status: "Pending",
          isPaymentCompleted: false,
          createdAt: new Date()?.toString(),
          kycHistory: [
            {
              action: "Registration",
              status: "Initiated",
              createdAt: new Date()?.toString(),
              description: "User initiated registration",
              name: payload?.firstName + " " + payload.lastName,
            },
          ],
        },
        () => {
          sendEmail
            .mutateAsync({
              to: [payload?.personalEmail],
              from: "noreply@yess.com",
              subject: `Registration Successfull! Here's Your Temporary Login Information`,
              html: `<div style='font-family: Arial, sans-serif; color: #333;'> <h1 style='text-align: center; color: #003366;'>World Defense Show 2025 Registration</h1> <p style='text-align: center; font-size: 18px;'>Thank you for registering for the World Defense Show 2025! Your registration is now pending vetting approval. We will email you regarding the status of your registration.</p>  <h3>Next Steps:</h3> <ul style='margin-left: 20px;'> <li>In January 2025, we will email your print-at-home badge.</li> <li>Save the date: <strong>5th - 8th February 2025</strong> for World Defense Show.</li> <li>Please ensure your visa details are completed if traveling from abroad.</li> </ul> <p style='margin-top: 20px; text-align: center;'>For any further assistance, please contact our team </p> <footer style='text-align: center; margin-top: 40px;'> <p>Kind regards,</p> <p>The World Defense Show Team</p> </footer> </div> </div>`,
              body: "",
            })
            .then((result) => {});
          navigate("/auth/login");
        }
      )
    );
  };

  useEffect(() => {
    dispatch(getTypes());
    dispatch(getCountries());
    // eslint-disable-next-line
  }, []);

  return (
    <Flex
      minH="100vh"
      py="20px"
      px="150px"
      flexDir="column"
      gap="50px"
      backgroundImage={`url(${BgImg})`}
      backgroundSize="cover"
      backgroundPosition="top"
      backgroundRepeat="no-repeat"
    >
      <Flex align="center" justify="space-between">
        <Image src={Logo} alt="Logo" w="124px" h="54px" />
        <Image src={WdsLogo} alt="WDS Logo" w="124px" h="54px" />
      </Flex>
      <Flex flexDir="column" gap="24px">
        <Box
          maxW="1296px"
          w="100%"
          mx="auto"
          mb="24px"
          boxShadow="0px 3px 4px 0px rgba(0, 0, 0, 0.03)"
          p="24px"
          borderRadius="24px"
          border="1px solid #e4e4e4"
          bg="#fff"
        >
          <CustomText
            text="Complete your Registration"
            size="24px"
            weight="700"
            color="yess.base_black"
          />
          <Box mb="40px" />
          <Flex flexDir="column" gap="24px">
            <CompanyInfo payload={payload} setPayload={setPayload} />
            <PersonalInfo
              payload={payload}
              setPayload={setPayload}
              isPassword={true}
            />
            <AboutYou payload={payload} setPayload={setPayload} />
            <Documents payload={payload} setPayload={setPayload} />
          </Flex>
          <Flex
            borderTop="1px solid #F2F2F2"
            pt="16px"
            justify="end"
            gap="10px"
            mt="20px"
          >
            <CustomButton
              btnTitle="Register"
              maxW="160px"
              bg="yess.secondary_gold"
              isLoading={loading}
              onClick={() => {
                if (
                  !payload.companyName ||
                  !payload.jobTitle ||
                  !payload.companyEmail ||
                  !payload.companyLocation ||
                  !payload.companyPhone ||
                  !payload.companyAddress ||
                  !payload.companyCity ||
                  !payload.firstName ||
                  !payload.lastName ||
                  !payload.personalEmail ||
                  !payload.dateOfBirth ||
                  !payload.nationality ||
                  !payload.personalPhone ||
                  !payload.personalCountry ||
                  !payload.personalCity ||
                  !payload.personalAddress ||
                  payload.documentUrls.length === 0 ||
                  !payload?.profileImg ||
                  !payload?.password
                ) {
                  toast({
                    title: "Please fill in all required fields",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                  });
                  return;
                }

                handleUpdateVisitor();
              }}
            />
          </Flex>
        </Box>
      </Flex>
    </Flex>
  );
}

export default Register;
